<template>
  <div>
    <div class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
        class="child"
        cardTitle="ENDPOINTS"
        :endpoints="endpoints"
      />
      <TextArea
        class="child"
        :textTitle="filteringTitle"
        :textLinesArray="filteringText"
      ></TextArea>
    </div>
    <div :ref="endpoints[0].ref" class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
      class="child"
      :response="response"
      :cardTitle="responseCodeTitle"
      />
      <Attribute
        class="child"
        :attributes="attributesWorksheets"
        endpoint="Worksheets Object"
      />
      <Attribute
        class="child"
        :attributes="attributesFitters"
        endpoint="Fitters Object"
      />
      <Attribute
        class="child"
        :attributes="attributesResourceGroups"
        endpoint="ResourceGroups Object"
      />
    </div>
    <div :ref="endpoints[2].ref" class="container">
      <Attribute
        class="child"
        :attributes="attributesCategories"
        :endpoint="responseTitleCategories"
      />
      <ResponseCard
        class="child"
        :response="responseCategories"
        :cardTitle="responseCodeTitleCategories"
      />
    </div>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  flex-flow: row wrap;
  padding-left: 10rem;
  padding-right: 10rem;
}

.child {
  min-width: 40%;
  max-width: 45%;
  flex-grow: 1;
  flex-shrink: 1;
}

@media screen and (max-width: 500px) {
  .container {
    flex-flow: column wrap;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .child {
    max-width: 380px;
    min-width: 300px;
  }
}
</style>
<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
  },
  created() {
    this.$root.$on("scrollToEndpoint", (ref) => {
      var element = this.$refs[ref];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    });
  },
  computed: {
    endpointName() {
      return this.$t("calendareventsV4.endpointTitle");
    },
    filteringTitle() {
      return this.$t("calendareventsV4.filteringTitle");
    },
    filteringText() {
      return this.$t("calendareventsV4.filteringText");
    },
    responseTitle() {
      return this.$t("calendareventsV4.getTitle");
    },
    responseTitleCategories() {
      return this.$t("calendareventsV4.getTitleCategories");
    },
    responseCodeTitle() {
      return this.$t("calendareventsV4.responseCodeTitle");
    },
    responseCodeTitleCategories() {
      return this.$t("calendareventsV4.responseCodeTitleCategories");
    },
    endpointDesc() {
      return this.$t("calendareventsV4.endpointDesc");
    },
    endpoints() {
      return this.$t("calendareventsV4.controllerEndpoints");
    },
    response() {
      return this.$t("calendareventsV4.getResponseEvents");
    },
    attributes() {
      return this.$t("calendareventsV4.getAttributesEvents");
    },
    attributesWorksheets() {
      return this.$t("calendareventsV4.getAttributesWorksheets");
    },
    attributesFitters() {
      return this.$t("calendareventsV4.getAttributesFitters");
    },
    attributesResourceGroups() {
      return this.$t("calendareventsV4.getAtributesResourceGroups");
    },
    responseCategories() {
      return this.$t("calendareventsV4.getResponseCategories");
    },
    attributesCategories() {
      return this.$t("calendareventsV4.getAttributesCategories");
    },
  },
};
</script>
